<page-grid [gridConfig]="gridConfig()" (gridClickColumn)="handleColumnClick($event)">
  <ng-template #actionItem let-item="item">
    <button
      mat-icon-button
      color="primary"
      aria-label="Manual ERP Update"
      matTooltip="Manually record ERP send (sales order number, timestamp) for this order"
      (click)="openManualUpdateDialog(item)">
      <mat-icon fontIcon="edit_note" />
    </button>
  </ng-template>
</page-grid>
